import React from "react";
import { Box, Typography, Grid, Button } 
from "@mui/material"; 
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { button, headerText, paddingbox, underheaderText } from "../../style2";
//import { useStyles } from "../../style";

function Header({
  show_welcome_message,
  show_back_button,
  show_profile_button,
}) {
  //const classes = useStyles();
  const professional = useSelector((state) => state.professional.value);

  return (
      <Box sx={paddingbox}>
        <Grid container justifyContent='flex-start'>
          <Grid item order={{ sm: 2 }}>
            {show_welcome_message ? (
              <div>
                <Typography sx={headerText}>
                  Welcome, {professional.title} {professional.name}!
                </Typography>
                <Typography sx={underheaderText}>
                  Professional Number {professional.registrationNo}
                </Typography>
              </div>
            ) : (
              <Typography sx={headerText}></Typography>
            )}
          </Grid>
          <Grid item order={{ sm: 1 }}>
            <Grid container sm justifyContent='flex-end' alignItems='center'>
              {/* {show_back_button ? (
                <div>
                  <Button
                    className={classes.buttonback}
                    component={Link}
                    to='/'
                  >
                    <ArrowBackIcon />&nbsp; Back
                  </Button>
                </div>
              ) : null} */}
              <Box m={2} />
              {show_profile_button ? (
                <Button
                  sx={button}
                  component={Link}
                  to='/professional_profile'
                >
                  My Profile
                </Button>
              ) : null}
              <Box m={1} />
              {/* <NotificationsIcon className={classes.IconBell} /> */}
            </Grid>
          </Grid>
        </Grid>
      </Box>
  );
}

export default Header;
